export default __webpack_public_path__ + "static/media/support.eef7594a.png";